import { useRegisterAPIService } from '@elfsight/widget-js-api';
import { type FormField, useFormDispatch } from '../../contexts';
import { API_FORM_SERVICE_NAME, API_SET_VALUE_METHOD_NAME } from './constants';
import { validateAPIValue } from './utils';

function formFieldFinder(targetId: string, sourceFields: FormField[]) {
  return sourceFields.find(
    ({ fieldID, id: itemId }) =>
      `[${fieldID}]` === targetId || itemId === targetId
  );
}

type GetDispatchFieldValueProps = {
  targetId: string;
  targetValue: unknown;
  fields: FormField[];
};

function getDispatchFieldValue({
  targetId,
  targetValue,
  fields
}: GetDispatchFieldValueProps) {
  const field = formFieldFinder(targetId, fields);
  if (!field) {
    return;
  }

  const validationParams = validateAPIValue(targetValue, field);
  const { id } = field;
  if (id && validationParams) {
    const [derivedValue, isValid] = validationParams;

    return { id, value: derivedValue, valid: isValid };
  }

  return;
}

export function useRegisterFormService(fields: FormField[]) {
  const dispatch = useFormDispatch();

  useRegisterAPIService(
    API_FORM_SERVICE_NAME,
    () => ({
      [API_SET_VALUE_METHOD_NAME]: (targetId, targetValue) => {
        if (targetValue === null || targetValue === undefined) {
          return;
        }

        const dispatchFieldValue = getDispatchFieldValue({
          targetId,
          targetValue,
          fields
        });

        if (dispatchFieldValue) {
          dispatch({
            type: 'changeField',
            field: dispatchFieldValue
          });
        }
      }
    }),
    [dispatch, fields]
  );
}
